// export default function Page(){
//   return (
//     <div className="page">
//       <h1>Contact Us</h1>
//       <p>Dummy content for Contact Us.</p>
//       <img src="https://via.placeholder.com/800x300" alt="dummy"/>
//     </div>
//   );
// }

import React from "react";
import "../styles/contact.css";
import heroImg from "../assets/images/Contact-us.jpg";
import logo from "../assets/images/logo.jpeg";

const Contact = () => {
  return (
    <div className="contact-page">
      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-left">
          <h1>
            Exceptional Facilities Management Solutions Available Across the UK
          </h1>
        </div>

        <div className="contact-hero-right">
          <img src={heroImg} alt="" />
        </div>
      </section>

      {/* INTRO */}
      <section className="contact-intro">
        <p>
          From day-to-day management to complete facilities support, our trained
          professionals are committed to maintaining high standards and
          exceptional service delivery.
        </p>
      </section>

      {/* FORM + INFO */}
      <section className="contact-main">
        {/* FORM */}
        <div className="contact-form">
          <h2>Contact Us</h2>
          <p className="required">Fields marked with * are required</p>

          <form>
            <label>Name *</label>
            <input type="text" />

            <div className="row">
              <div>
                <label>Email *</label>
                <input type="email" />
              </div>

              <div>
                <label>Phone *</label>
                <input type="text" />
              </div>
            </div>

            <label>Message *</label>
            <textarea rows="6"></textarea>

            <button type="submit" className="contact-btn">
              SUBMIT
            </button>
          </form>
        </div>

        {/* INFO */}
        <div className="contact-info">
          <h2>Contact info</h2>
          <p>
            <strong>COLIPS Facilities Management</strong>
          </p>
          <p>Phone: 07459454530</p>
          <p>Tel: 07438422831</p>
          <p>Email: info@colipsiltd.com</p>

          <div className="contact-logo">
            <img src={logo} alt="logo" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
